import { create } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";
import { decryptData, encryptData } from "../utils/encrypt";


const globalFilterStore = create(
    devtools(
        persist(
            (set, get) => ({
                commonFilter: {
                    projects: [],
                    sprint: [],
                    issueType: [],
                    subProject: [],
                    reporters: [],
                    issueKey: "",
                    month: new Date(),
                    isChange: false,
                    groupBy: "feature",
                    taskType: true
                },
                projectWiseData: {
                    sprint: [],
                    issueType: [],
                    subProject: [],
                    reporters: []
                },
                setCommonFilter: (updates) => {
                    set((state) => {
                        const newState = {
                            commonFilter: {
                                ...state.commonFilter,
                                ...updates
                            }
                        };
                        return newState;
                    });
                },
                setProjectWiseData: (data) => {
                    set((state) => ({
                        projectWiseData: data
                    }));
                }
            }),
            {
                name: "filter-storage",
                storage: createJSONStorage(() => ({
                    getItem: (name) => {
                        try {
                            const encryptedData = sessionStorage.getItem(name);
                            if (!encryptedData) return null;
                            return decryptData(encryptedData);
                        } catch (error) {
                            sessionStorage.removeItem(name);
                            return null;
                        }
                    },
                    setItem: (name, value) => {
                        try {
                            const encryptedData = encryptData(value);
                            sessionStorage.setItem(name, encryptedData);
                        } catch (error) {
                        }
                    },
                    removeItem: (name) => {
                        sessionStorage.removeItem(name);
                    }
                })),
                partialize: (state) => ({
                    commonFilter: state.commonFilter,
                    projectWiseData: state.projectWiseData
                })
            }
        )
    )
);

export default globalFilterStore;
